const COURSE_THEMES = [
  {
    primary: '#16b5c5',
    secondary: '#2a88e9',
    accent: '#ff9d00',
    deep: '#0f7690',
    soft: '#a7edf5'
  },
  {
    primary: '#8f194c',
    secondary: '#d50d7a',
    accent: '#ff9d00',
    deep: '#651136',
    soft: '#ffb7d4'
  },
  {
    primary: '#5264d6',
    secondary: '#4045ab',
    accent: '#8f9bff',
    deep: '#32378a',
    soft: '#b7c1ff'
  },
  {
    primary: '#77b338',
    secondary: '#43b776',
    accent: '#ff9d00',
    deep: '#4d8722',
    soft: '#c9ef98'
  },
  {
    primary: '#ff2442',
    secondary: '#ce30d6',
    accent: '#ff8b3d',
    deep: '#bb1731',
    soft: '#ffc0cc'
  },
  {
    primary: '#14b0c7',
    secondary: '#4caf33',
    accent: '#92d625',
    deep: '#10889b',
    soft: '#b6efd3'
  }
]

const hashString = (value = '') => {
  return String(value)
    .split('')
    .reduce((hash, char) => ((hash * 33) + char.charCodeAt(0)) >>> 0, 0)
}

const resolveThemeSeed = (course = {}) => {
  const numericSeed = Number(course.id || 0)

  if (Number.isFinite(numericSeed) && numericSeed > 0) {
    return numericSeed
  }

  const fallback = [
    course.category_two_name,
    course.category_one_name,
    course.title
  ].filter(Boolean).join('|')

  return hashString(fallback)
}

export const getCourseTheme = (course = {}) => {
  const seed = resolveThemeSeed(course)
  return COURSE_THEMES[seed % COURSE_THEMES.length]
}

export const getCourseThemeStyle = (course = {}) => {
  const theme = getCourseTheme(course)

  return {
    '--course-theme-primary': theme.primary,
    '--course-theme-secondary': theme.secondary,
    '--course-theme-accent': theme.accent,
    '--course-theme-deep': theme.deep,
    '--course-theme-soft': theme.soft
  }
}

export const getCourseMonogram = (course = {}) => {
  const source = course.category_two_name || course.category_one_name || course.title || '课'
  return String(source).slice(0, 2)
}
